import React from 'react';
import { Typography, Grid, Paper, Box } from '@material-ui/core';
import PeopleIcon from '@material-ui/icons/People';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import ListAltIcon from '@material-ui/icons/ListAlt';
import RepeatIcon from '@material-ui/icons/Repeat';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 16,
    padding: theme.spacing(3),
    background: '#f8f9fa',
    border: '1px solid #e9ecef',
    height: '100%',
  },
  title: {
    fontWeight: 700,
    fontSize: '1.1rem',
    color: '#2d3748',
    marginBottom: theme.spacing(2),
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: theme.spacing(1.2, 0),
    borderBottom: '1px solid #e9ecef',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  icon: {
    color: '#667eea',
    fontSize: '1.3rem',
  },
  label: {
    color: '#8898aa',
    fontSize: '0.9rem',
    fontWeight: 500,
  },
  value: {
    color: '#2d3748',
    fontWeight: 700,
    fontSize: '1rem',
    marginLeft: 'auto',
  },
}));

function ShippingDetails(props) {
  const { formValues } = props;
  const classes = useStyles();
  const { plan } = formValues;
  const newPlan = JSON.parse(plan);
  const { users, connections, queues } = newPlan;

  return (
    <Grid item xs={12} sm={6}>
      <Paper elevation={0} className={classes.paper}>
        <Typography className={classes.title}>
          Detalhes do plano
        </Typography>
        <Box className={classes.row}>
          <PeopleIcon className={classes.icon} />
          <Typography className={classes.label}>Usuários</Typography>
          <Typography className={classes.value}>{users}</Typography>
        </Box>
        <Box className={classes.row}>
          <DeviceHubIcon className={classes.icon} />
          <Typography className={classes.label}>Conexões</Typography>
          <Typography className={classes.value}>{connections}</Typography>
        </Box>
        <Box className={classes.row}>
          <ListAltIcon className={classes.icon} />
          <Typography className={classes.label}>Filas</Typography>
          <Typography className={classes.value}>{queues}</Typography>
        </Box>
        <Box className={classes.row}>
          <RepeatIcon className={classes.icon} />
          <Typography className={classes.label}>Cobrança</Typography>
          <Typography className={classes.value}>Mensal</Typography>
        </Box>
      </Paper>
    </Grid>
  );
}

export default ShippingDetails;
